import React from "react";
import "../styles/Section.css";

const cases = [
  {
    name: "RetailX E-Commerce Platform",
    problem: "Outdated system with low conversion rate.",
    solution: "Rebuilt frontend with optimized UX and scalable backend.",
    result: "38% increase in online sales."
  },
  {
    name: "FinTech Dashboard",
    problem: "Complex financial reporting and slow processing.",
    solution: "Developed real-time data dashboard with secure APIs.",
    result: "Reduced reporting time by 50%."
  }
];

const Cases = () => {
  return (
    <section id="cases" className="section">
      <h2>Case Studies</h2>
      <div className="cards">
        {cases.map((project, index) => (
          <div key={index} className="card animate">
            <h3>{project.name}</h3>
            <p><strong>Problem:</strong> {project.problem}</p>
            <p><strong>Solution:</strong> {project.solution}</p>
            <p><strong>Result:</strong> {project.result}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Cases;